<template>
  <v-list-tile :key="method.paymentMethodId || method"
    class="py-2"
    @click="$emit('click')"
    two-line
  >
    <v-list-tile-action v-if="image" style="min-width: 30px; margin-right: 10px">
      <v-img
        :height="45"
        :width="70"
        :src="image"
        :cover="method != 'offline'"
        :contain="method == 'offline'"
      />
    </v-list-tile-action>

    <v-list-tile-content v-if="$vuetify.breakpoint.smAndUp || !hideText">
      <v-list-tile-title>
        {{ title }}
      </v-list-tile-title>

      <v-list-tile-sub-title v-html="subTitle">
      </v-list-tile-sub-title>
    </v-list-tile-content>

    <card-error-chip :card="method" @CardError="hideText = true" />

    <v-list-tile-action v-if="!hideText" id="selectedAction">
      <v-icon v-if="isSelectedMethod" color="green">
        check
      </v-icon>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
import CardErrorChip from '@/components/Account/CardErrorChip.vue'

export default {
  components: { CardErrorChip },

  props: {
    method: [Object, String],
    image: String,
    index: Number,
    title: String,
    subTitle: String
  },

  data: () => ({
    // We need the action area and title on mobile to make room for the card error
    hideText: false
  }),

  computed: {
    isSelectedMethod() {
      return this.$parent.$parent.$parent.$parent.$parent.isSelectedMethod(this.method, this.index)
    }
  }
}
</script>

<style scoped>
  #selectedAction {
    min-width: 30px !important;
    max-width: 30px !important
  }
</style>
